import React from "react";
import "./Streak.css";
import { ReactComponent as ChartIcon } from "../../icons/streak.svg";

function Streak({ currentStreak, streakImprovementPercentage, maxStreak }) {
  const getDaysDeclension = (number) => {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
      return "дней";
    }

    if (lastDigit === 1) {
      return "день";
    }

    if (lastDigit >= 2 && lastDigit <= 4) {
      return "дня";
    }

    return "дней";
  };

  return (
    <div className="streak-card">
      <h3>
        <ChartIcon className="header-emoji" />
        <span className="header-text">Текущий стрик</span>
      </h3>
      <div className="streak-main-content">
        <p className="streak-days">
          <strong>
            {currentStreak} {getDaysDeclension(currentStreak)}
          </strong>
        </p>
        <div className="streak-percentage">
          <span>+{streakImprovementPercentage}%</span>
        </div>
      </div>
    </div>
  );
}

export default Streak;
